import React from 'react'
import { connect } from "react-redux"
import { withRouter } from 'react-router'
import sortBy from 'lodash/sortBy'
import loaderImg from '../practice_admin/images/loader.gif'

import PracticePatientRow from '../practice_admin/PracticePatientRow'

import { setTitle } from "../../actions/index"
import { fetchTherapistPatientsForPractice, setPractice } from '../../actions/therapist'

import SearchIcon from '../../images/icons/SearchIcon'

@connect((store) => {
    return { User: store.User.User, app: store.app, patients: store.patients }
})
class TherapistPractice extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            'fetchedPatients': false,
            'filterBy': 'unarchived',
            'sortBy': 'firstName',
            'search': '',
            'loading': true
        }
        this.filterByChange = this.filterByChange.bind(this);
        this.filterPatients = this.filterPatients.bind(this);
        this.sortByChange = this.sortByChange.bind(this);
        this.actionButtons = this.actionButtons.bind(this);
        this.onSearchChange = this.onSearchChange.bind(this)
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.patients !== this.props.patients) {
            return true;
        } else if (nextState !== this.state) {
            return true;
        }
        return false;
    }

    componentDidMount() {
        this.props.dispatch(setTitle('Therapist'))
        this.props.dispatch(setPractice({}));
    }

    componentWillReceiveProps(nextProps) {
        const { fetchedPatients } = this.state;
        const { params, User } = this.props;

        if (params.practiceId !== nextProps.params.practiceId || !fetchedPatients) {
            this.props.dispatch(fetchTherapistPatientsForPractice(User._id, params.practiceId))
                .then(r => {
                    this.setState({
                        'fetchedPatients': true,
                        'loading': false
                    })
                })
        }
    }

    filterByChange(event){
        this.setState({ filterBy: event.target.value });
    }

    sortByChange(event){
        this.setState({ sortBy: event.target.value });
    }

    actionButtons(patient){
        return '';
    }

    filterPatients(patients) {
        let { filterBy } = this.state;
        let users = [];
        // console.log(filterBy);
        // console.log(patients);
        patients.forEach(patient => {
            // console.log(patient);
            if (filterBy === 'all') {
                users.push(patient);
            } else if (filterBy === 'archived' && patient.archived) {
                users.push(patient);
            } else if (filterBy === 'unarchived' && !patient.archived) {
                users.push(patient);
            }
        });

        return users;
    }

    onSearchChange(e) {
        // console.log(e.target.value)
        this.setState({
        'search': e.target.value
        })
        
    }

    render() {

        let { loading } = this.state
        let _users = this.filterPatients(this.props.patients);
        // console.log('here')

        if (loading) {
            const divStyle = {
                'paddingTop': '50px',
                'fontSize': '.4em',
                'position': 'fixed',
                'transform': 'translate(-50%, -50%)',
                'top': '40%',
                'left': '50%',
                'display': 'flex',
                'flexDirection': 'column',
                'alignItems': 'center',
                'justifyContent': 'center'
            };
            
			
			// Need to style loading
			return (<div>
				<main className={"main"}>
					<div className="padding">
						<h4 style={divStyle}>
							<img src={loaderImg} alt=""/>
							<small>Loading</small>
						</h4>
					</div>
				</main>
			</div>);
		}

        if (this.state.search.length > 0) {
            let search = this.state.search;
            const s = new RegExp(`^${search.trim().toLowerCase()}`, 'gi')

            _users = _users.filter(function (user) {
                let fname = user.firstName + ' ' + user.middleNames + ' ' + user.lastName;
                return fname.toLowerCase().match(s);
            });
        }
        return (<main className="main">
            {/* FILTER */}
            <div className="patientFilter">
                <div className="typeFilter">
                    <label htmlFor="typeFilter">Filter By:</label>
                    <select value={this.state.filterBy} onChange={this.filterByChange}>
                        <option value="unarchived">Active</option>
                        <option value="archived">Archived</option>
                        <option value="all">All</option>
                        </select>
                </div>
                {/* <div className="dateFilter">
                    <label htmlFor="typeFilter">Sort by:</label>
                    <select value={this.state.sortBy} onChange={this.sortByChange}>
                        <option value="firstName">Name</option>
                        <option value="created">Date</option>
                        </select>
                </div> */}
                <div className="searchContainer">
                    <div className="search-box__content">
                        <div className="search-box__input">
                            <SearchIcon />
                            <input type="search" onChange={this.onSearchChange} value={this.state.search} placeholder="Search for Patient" />
                        </div>
                    </div>
                </div>
            </div>
            {/* FILTER */}
            {(_users.length > 0) ? <div>
                <ul className="md-list card patientList mb8">
                    <li className="card-header">Patients for {this.props.params.name}</li>

                    {sortBy(_users, [this.state.sortBy]).map(patient => <PracticePatientRow 
                        to={`/therapists/practice/${this.props.params.practiceId}/patient/${patient._id}`} 
                        key={patient._id} 
                        patient={patient} 
                        actionButtons={this.actionButtons}    
                        />)}

                </ul>
            </div>: <div>No {this.state.filterBy} patients.</div>
            }
        </main>)
    }
}

export default withRouter(TherapistPractice);



// WEBPACK FOOTER //
// ./src/components/therapist/TherapistPractice.jsx